import { createRoot, type Root } from 'react-dom/client'
import { App } from '../app'

const roots = new WeakMap<Element, Root>()

/**
 * SharePoint / SPFx entry helper.
 * In an SPFx web part, call this from `render()` with `this.domElement`.
 */
export function mountDaycareApp(container: Element): () => void {
  let root = roots.get(container)
  if (!root) {
    root = createRoot(container)
    roots.set(container, root)
  }
  root.render(<App />)
  return () => {
    root?.unmount()
    roots.delete(container)
  }
}
